module.exports = __webpack_public_path__ + "img/add-issue-forms-new.1ae203c4.svg";